import React, { useMemo } from "react";

import IconButton from "@cayuse/shared-react.components.icon-button";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Dropdown from "components/Dropdown";
import { useDictionary } from "hooks";
import { generatePeriodDropdownItems } from "utils/budgetBuilder";

import styles from "./styles.css";

const CopyToFromRow = ({ rowData, periods, onRowChange, onAdd, onRemove, index, editable, size }) => {
	const dictionary = useDictionary("budgetBuilder.components.PeriodDropdown");
	const { dateFormatter } = useTenantFormatter();
	
	const changeRow = (newData, type) => {		
		onRowChange(index, newData, type);
	};

	const dropdownOptionsFrom = useMemo(
		() => generatePeriodDropdownItems(
			periods,
			dateFormatter,
			dictionary.periodOf || "Period {periodNumber} of {numberOfPeriods}",
		).filter(period => period.value !== rowData.to),
		[ periods, rowData ]);

	const dropdownOptionsTo = useMemo(
		() => generatePeriodDropdownItems(
			periods,
			dateFormatter,
			dictionary.periodOf || "Period {periodNumber} of {numberOfPeriods}",
		).filter(period => period.value !== rowData.from),
		[ periods, rowData ]);

	return (
		<>			
			<div className="three wide computer seven wide device column">
				<Dropdown
					disabled={!editable}
					className={styles.dropdown}
					selection
					placeholder={"Select a period..."}
					options={dropdownOptionsFrom}
					onChange={(event, { value }) => changeRow({ from: value }, "from")}
					value={rowData.from || null}
				/>
			</div>
			<div className="three wide computer seven wide device column">
				<Dropdown
					disabled={!editable}
					className={styles.dropdown}
					selection
					placeholder={"Select a period..."}
					options={dropdownOptionsTo}
					onChange={(event, { value }) => changeRow({ to: value }, "to")}
					value={rowData.to || null}
				/>
			</div>
			<div className="one wide column">
				{editable && (index > 0 || size > 1) && (
					<IconButton
						className={`${styles.rowIcon} ${styles.red}`}
						icon="times"
						size="bigger"
						onClick={() => onRemove(index)}
						tertiary
					/>
				)}
			</div>
			<div className="one wide column">
				{editable && index === size - 1 && (
					<IconButton
						className={`${styles.rowIcon} ${styles.blue}`}
						icon="plus"
						size="bigger"
						onClick={() => onAdd()}
						tertiary
					/>
				)}
			</div>
		</>
	)
};

export default CopyToFromRow;
